import React from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { API } from 'aws-amplify';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import Coordinates from '../FormComponents/Coordinates'
import RunPeriod from '../FormComponents/RunPeriod'
import JobIds from '../FormComponents/JobIds'
import OnSiteFile from '../FormComponents/OnSiteFile'
import Pollutants from '../FormComponents/Pollutants'
import DropDown from "../FormComponents/DropDown"
import BuildStacks from '../FormComponents/BuildStacks'
import STACK_CONFIG from '../AERMOD/config/BuildStack.json'
import Receptors from '../FormComponents/Receptors'
import SingleSwitch from '../FormComponents/SingleSwitch'
import AersurfaceCategories from '../FormComponents/AersurfaceCategories'
import AersurfaceClimate from '../FormComponents/AersurfaceClimate'
import FileSelect from '../FormComponents/FileSelect'
import MetStationMap from '../FormComponents/MetStationMap'
import TextOption from '../FormComponents/TextOption'
import FileUpload from './FormComponents/FileUpload'
import MapContainer from './FormComponents/MapContainer'

import { styles, translateRequestBody, validateRequestBody, stackInit } from './util'

const d = new Date()

class AERMODForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            runOption: 'default',
            startYear: 2015,
            endYear: 2019,
            latitude: null,
            longitude : null,
            stateACRONYM: '',
            no2: false,
            so2: false,
            pm25: false,
            pm10: false,
            lead: false,
            co: false,
            other: false,
            osLat:'',
            osLon:'',
            osElev:'',
            inStackRatio: 0.5,
            backgroundOzoneValue: 70,
            source: {
                1 : stackInit['source']
            },
            aermodStackSourceLocationFile: '',
            fenceLineLocationFile: '',
            buildingLocationFile: '',
            grid1LowerBoundary: 0,
            grid1UpperBoundary: 500,
            grid1Spacing: 50,
            grid2UpperBoundary: 8000,
            grid2Spacing: 100,
            grid3UpperBoundary: 10000,
            grid3Spacing: 0,
            onsiteMeteorologicalDataFile: '',
            wrfAndMMIF: false,
            useAersurfaceCategories: false,
            useAersurfacePrecip: false,
            stmet: false,
            aersurfaceJan: 3,
            aersurfaceFeb: 3,
            aersurfaceMar: 5,
            aersurfaceApr: 5,
            aersurfaceMay: 5,
            aersurfaceJun: 1,
            aersurfaceJul: 1,
            aersurfaceAug: 1,
            aersurfaceSep: 1,
            aersurfaceOct: 2,
            aersurfaceNov: 2,
            aersurfaceDec: 3,
            asfc_yr1P: 'WET',
            asfc_yr2P: 'WET',
            asfc_yr3P: 'WET',
            asfc_yr4P: 'WET',
            asfc_yr5P: 'WET',
            sensitiveRecCheck: false,
            useDefaultMetCheck: false,
            selectedSurfaceStation: '{"name":"today"}',
            selectedUpperAirStation: '{"name":"today"}',
            hourlyEmissionsDataFile:'',
            modelDescription: ``,
            buildingGeojson: null,
            fencelineGeojson: null,
            drawnBuildings: [],
            drawnFencelines: [],
            validationError: '',
            requestId: null,
            previousMet: '',
            previousRec: '',
            previousProj: '',
            adjU:true,
            splitAermod:false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleStackInputChange = this.handleStackInputChange.bind(this);
        this.handleLoadProjChange = this.handleLoadProjChange.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);
        this.createStack = this.createStack.bind(this);
        this.removeStack = this.removeStack.bind(this);

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;

        this.setState({
            [name]: value
        });
    }
    handleLoadProjChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        console.log(value,name)
        this.setState({
            [name]: value
        });

        //this.api_post_loadproj(value,name)
    }
    handleStackInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        const id = target.id;
        const stacktype = target.attributes.stacktype.value;

        this.setState({
            [stacktype]: {
                ...this.state[stacktype],
                [id]: {
                    ...this.state[stacktype][id],
                    [name]: value
                }
            }
        });
    }

    createStack(stacktype){
        // The new id will be the current max id + 1
        const id = Math.max.apply(null, Object.keys(this.state[stacktype]).map(Number)) + 1;

        this.setState({
            [stacktype]: {
                ...this.state[stacktype],
                [id]: stackInit[stacktype]
            }
        });
    }

    removeStack(stacktype){
        // The id we will be removing is the current max id
        const id = Math.max.apply(null, Object.keys(this.state[stacktype]).map(Number));

        if (id > 1) {
            // Remove the object from the stack
            let stacktypeObject = this.state[stacktype]
            delete stacktypeObject[id]

            this.setState({
                [stacktype]: stacktypeObject
            });
        }
    }

    /*
    api_post_aermod(request) {
        let options = {
            body: request,
            headers: {},
            response: true
        }

        this.setState({requestId: 'Loading'});

        API.post("AQcast", "/request/aermod/", options)
            .then(response => {
                this._isMounted && this.setState({requestId: response.data.requestId});
            })
            .catch(error => {
                this._isMounted && this.setState({validationError: 'error.errorMessage'});
                console.log(error)
            })
    }

    handleSubmit(event) {
        event.preventDefault()
        // Check if the user has left any necessary fields blank
        const errorString = validateRequestBody(this.state)
        if (errorString) {
            this.setState({
                validationError: errorString
            })
            // alert(errorString);
        } else {    // Submit normally
            this.setState({
                validationError: errorString
            })

            const requestBody = translateRequestBody(this.state)
            //this._isMounted && this.api_post_aermod(requestBody)
        }
        event.preventDefault();
    }
    */
    displayJobResultLink(){
        if (this.state.requestId === null){
            return null
        } else if (this.state.requestId === undefined) {
            return (
                <b style={{color: 'red'}}>
                    Meteorological Allowances = 0  (purchase more or use met from previous run.)
                </b>
            )
        } else if (this.state.requestId ==='Error') {
            return (
                <b style={{color: 'red'}}>
                    Error submitting job
                </b>
            )
        } else if (this.state.requestId ==='Loading') {
            return (
                <span >
                    Submitting Job...
                </span>
            )
        } else {
            return (
                <span>
                    <Button
                        className={classNames(this.props.margin)}
                        variant="text"
                        disabled={true}
                        color="default"
                        component={Link}
                        to={{
                            pathname: '/AERMODPreview/Results',
                            search: '?requestId=' + this.state.requestId
                        }}
                    > View results of job: {this.state.requestId} </Button>
                </span>
            )
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <form onSubmit={this.handleSubmit} >
                <div> <b>AERMOD/AERMET Version 19191</b></div>
                <div>
                    <b>Load Previous Project (Optional)<FaInfoCircle data-tip data-for='previousProj'/> </b>

                    <ReactTooltip id='previousProj' place="right" type="light" effect="solid">
                        Loading a previously run project will overwrite any inputs below.
                    </ReactTooltip>
                </div>
                <JobIds
                    classes={classes}
                    handleInputChange={this.handleLoadProjChange}
                    value={this.state.previousProj}
                    title='Select a Project description from a previous job to load'
                    name='previousProj'
                    model='AERMOD'
                />

                <div><b> - OR - </b></div>

                <TextOption
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Project Description:'
                    name='modelDescription'
                    maxLength='48'
                    placeholder="Ex: Boston NO2 MMIF 2019-01-03"
                    width='250px'
                    value={this.state.modelDescription}
                    tooltip={[<div key='modelDescription'>A short description for this model (reference only). Max Length: 48 characters, (Spaces, hyphens, and underscores only.)</div>]}
                />

                <DropDown
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Run Option:'
                    name='runOption'
                    value={this.state.runOption}
                    dropdownOptions={
                        [{
                            value: "default",
                            label: "Default"
                        }]
                    }
                    tooltip={[<div key='runOption0'><b>Default:</b> SIL comparison and basic design values.</div>]}
                />

                <RunPeriod
                    classes={classes}
                    startYear={this.state.startYear}
                    endYear={this.state.endYear}
                    handleInputChange={this.handleInputChange} />

                <Coordinates
                    classes={classes}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    handleInputChange={this.handleInputChange} />

                <TextOption
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='State'
                    name='stateACRONYM'
                    maxLength='2'
                    width='100px'
                    value={this.state.stateACRONYM}
                    placeholder='Example: KS'
                    tooltip={[<div key='runPeriod0'>Location of the facility. (State abbreviation, Kansas: 'KS')</div>]}
                />

                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Use State provided meteorology (optional)'
                    label='State meteorology available: [TX]'
                    name='stmet'
                    value={this.state.stmet}
                    tooltip={[<div key='stmet'> This option does NOT use a Met Token.  To add another state with provided meteorology, email aqcast@aer.com</div>]}
                />

                <Pollutants
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    no2={this.state.no2}
                    so2={this.state.so2}
                    pm25={this.state.pm25}
                    pm10={this.state.pm10}
                    lead={this.state.lead}
                    co={this.state.co}
                    other={this.state.other}
                    inStackRatio={this.state.inStackRatio}
                    backgroundOzoneValue={this.state.backgroundOzoneValue} />

                <BuildStacks
                    classes={classes}
                    handleInputChange={this.handleStackInputChange}
                    stack_config={STACK_CONFIG}
                    createStack={this.createStack}
                    removeStack={this.removeStack}
                    stackIDs={Object.keys(this.state.source)}
                    stack={this.state.source}
                    stackType='source'
                    title='Create New Source (required, but can load a previous source parameter file below)'
                    showStackSeperation='true'
                    required='true'/>


                <div><b style={{padding:'60px'}}>OR</b></div>
                <div className="form-input-container" style={{'height': '100px'}}>
                    <div style={{'width': '450px', 'float': 'left'}}>
                        <FileSelect
                            classes={classes}
                            handleInputChange={this.handleLoadProjChange}
                            value={this.state.aermodStackSourceLocationFile}
                            title='Select Previously Created Source Parameter File'
                            name='aermodStackSourceLocationFile'
                            tooltip={[<div key='stackSourceLocationFile0'>Will load a previously created source emissions/parameter file into above source tables for editing.</div>]}
                        />
                    </div>
                    <div style={{'width': '450px', 'float': 'left'}}>
                        <FileUpload
                            classes={classes}
                            handleInputChange={this.handleInputChange}
                            value={this.state.hourlyEmissionsDataFile}
                            title='Hourly Emissions'
                            name='hourlyEmissionsDataFile'
                            tooltip={[<div key='hourlyEmissionsDataFile'>Format must be correct. See User Guide for details</div>]}
                        />
                    </div>
                </div>

                <div className="form-input-container">
                    <b> Draw/Upload buildings and fencelines on the map: (optional)</b>
                </div>

                <MapContainer
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    source={this.state.source}
                    buildingGeojson={this.state.buildingGeojson}
                    fencelineGeojson={this.state.fencelineGeojson}
                    drawnBuildings={this.state.drawnBuildings}
                    drawnFencelines={this.state.drawnFencelines}/>

                <div className="form-input-container" style={{'height': '100px'}}>
                    <div style={{'width': '350px', 'float': 'left'}}>
                        <FileSelect
                            classes={classes}
                            handleInputChange={this.handleInputChange}
                            value={this.state.fenceLineLocationFile}
                            title='Previously Created Fence Line File'
                            name='fenceLineLocationFile'
                            tooltip={[<div key='fenceLineLocationFile0'><b>Not required.</b> Previously created fenceline file shown in list, or upload *.shp.zip or draw it above.</div>]}
                        />
                    </div>
                    <div style={{'width': '350px', 'float': 'left'}}>
                        <FileSelect
                            classes={classes}
                            handleInputChange={this.handleInputChange}
                            value={this.state.buildingLocationFile}
                            title='Previously Created Building File'
                            name='buildingLocationFile'
                            tooltip={[<div key='buildingLocationFile'><b>Not required.</b> Previously created buildings file shown in list, or upload *.shp.zip or draw it above.</div>]}
                        />
                    </div>
                </div>

                <Receptors
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    grid1LowerBoundary={this.state.grid1LowerBoundary}
                    grid1UpperBoundary={this.state.grid1UpperBoundary}
                    grid1Spacing={this.state.grid1Spacing}
                    grid2UpperBoundary={this.state.grid2UpperBoundary}
                    grid2Spacing={this.state.grid2Spacing}
                    grid3UpperBoundary={this.state.grid3UpperBoundary}
                    grid3Spacing={this.state.grid3Spacing}
                />

                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Sensitive Receptors (optional)'
                    label='Find and include sensitive receptors in the model output.'
                    name='sensitiveRecCheck'
                    value={this.state.sensitiveRecCheck}
                    tooltip={[<div key='sensitiveRecCheck'>Sensitive receptors such as churches, schools, and hospitals will be included in the results.</div>]}
                />

                <div><h3> AERSURFACE Options:</h3></div>
                <div style={{fontSize: '11px'}}>Default: Monthly sectors and 12 directional sectors will be used in calculating surface characteristics along with model defaults.</div>
                <div style={{fontSize: '11px'}}>Airport for all sectors will be used if the station is an airport. NLCD 2016, Impervious, and Canopy data will be used.</div>
                <br></br>
                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Seasonal Category (optional)'
                    label='Use below values for aersurface seasonal categories.'
                    name='useAersurfaceCategories'
                    value={this.state.useAersurfaceCategories}
                    tooltip={[<div key='useAersurfaceCategories'>If checked, the below input values will be used, otherwise the seasonality aspects will be calculated and determined based on meteorology.</div>]}
                />

                <AersurfaceCategories
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    aersurfaceJan={this.state.aersurfaceJan}
                    aersurfaceFeb={this.state.aersurfaceFeb}
                    aersurfaceMar={this.state.aersurfaceMar}
                    aersurfaceApr={this.state.aersurfaceApr}
                    aersurfaceMay={this.state.aersurfaceMay}
                    aersurfaceJun={this.state.aersurfaceJun}
                    aersurfaceJul={this.state.aersurfaceJul}
                    aersurfaceAug={this.state.aersurfaceAug}
                    aersurfaceSep={this.state.aersurfaceSep}
                    aersurfaceOct={this.state.aersurfaceOct}
                    aersurfaceNov={this.state.aersurfaceNov}
                    aersurfaceDec={this.state.aersurfaceDec}/>

                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.handleInputChange}
                        title='Climate Precipitation Category (optional)'
                        label='Use below inputs for aersurface climate moisture determination for each year: WET, DRY, AVG.'
                        name='useAersurfacePrecip'
                        value={this.state.useAersurfacePrecip}
                        tooltip={[<div key='useAersurfacePrecip'>If checked, the below input values will be used, otherwise the yearly climate moisture category will be calculated based on meteorology and climatic averages.</div>]}
                    />

                    <AersurfaceClimate
                        classes={classes}
                        handleInputChange={this.handleInputChange}
                        asfc_yr1P={this.state.asfc_yr1P}
                        asfc_yr2P={this.state.asfc_yr2P}
                        asfc_yr3P={this.state.asfc_yr3P}
                        asfc_yr4P={this.state.asfc_yr4P}
                        asfc_yr5P={this.state.asfc_yr5P}
                    />

                <div><h2>Meteorology Options:</h2></div>

                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='ADJ_U*  (optional)'
                    label='Use ADJ_U* for low wind stability in AERMET Stage 3.'
                    name='adjU'
                    value={this.state.adjU}
                    tooltip={[<div key='adjU'>If checked, ADJ_U* will be used in AERMET Stage 3 for low wind stability.</div>]}
                />

                <div><h3>Choose 1 meteorology source:</h3></div>
                <i><p>The priority of meteorology data options are as follows: MMIF, previous meteorology option, onsite meteorology,
                default stations, selected stations via the map.</p><p>(This means MMIF data overides any other options you may have selected.)</p></i>

                <SingleSwitch
                    classes={classes}
                    title='MMIF from WRF (optional)'
                    label='Use WRF with MMIF for meteorological data.'
                    name='wrfAndMMIF'
                    value={this.state.wrfAndMMIF}
                    tooltip={[<div key='wrfAndMMIF'>COMING SOON!!</div>]}
                />

                <FileUpload
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    value={this.state.onsiteMeteorologicalDataFile}
                    title='Onsite Meteorological Data'
                    name='onsiteMeteorologicalDataFile'
                    tooltip={[<div key='onsiteMeteorologicalDataFile'><b>Not required.</b> Delimited text file accepted. FORMAT: OSDY OSMO OSYR OSHR HT01 SA01 SW01 TT01 WD01 WS01.</div>]}
                />

                <OnSiteFile
                    classes={classes}
                    osLat={this.state.osLat}
                    osLon={this.state.osLon}
                    osElev={this.state.osElev}
                    handleInputChange={this.handleInputChange} />

                <MetStationMap
                    classes={classes}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    selectedSurfaceStation={this.state.selectedSurfaceStation}
                    selectedUpperAirStation={this.state.selectedUpperAirStation}
                    useDefaultMetCheck={this.state.useDefaultMetCheck}
                    model='AERMOD'
                    previousMet={this.state.previousMet}
                    handleInputChange={this.handleInputChange}
                />

                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Split AERMOD runs  (optional)'
                    label='Decrease run time by splitting AERMOD runs by receptor groups'
                    name='splitAermod'
                    value={this.state.splitAermod}
                    tooltip={[<div key='splitAermod'>If checked, each AERMOD run will be split into multiple runs with a different set of receptors, decreasing run time.</div>,
                            <div key='splitAermod1'>This option is usually not accepted by regulatory agencies, however it can provide initial results faster.</div>]}
                />

                <Button
                    className={classNames(classes.margin, classes.textField)}
                    type="submit"
                    variant="contained"
                    disabled={true}
                    color="primary"> Submit
                </Button>
                {this.displayJobResultLink()}
                <b style={{color:'red'}}>{this.state.validationError}</b>

            </form>
        )}
}


AERMODForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AERMODForm);
